export const VENDORS = "v1/vendors";
